var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ankh-list',{attrs:{"showBtnGroup":false,"showSearchForm":false},scopedSlots:_vm._u([{key:"table",fn:function(ref){
var height = ref.height;
return [_c('fans-record',{attrs:{"height":height}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }